<template>
  <div>
    <p
      style="
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #343434;
        margin-bottom: 25px;
      "
    >
      物流产品信息
    </p>
    <div class="Item_Right animate__animated animate__bounceInRight">
      <div class="header_text">
        <p class="coutText">
          <span class="littit">物流产品</span>
          <span class="fontString"
            >{{ logisticsProductOrderDTO.productName
            }}{{
              logisticsProductOrderDTO.containsTheTariffs ? "包税" : "不包税"
            }}</span
          >
        </p>
        <p class="coutText">
          <span class="littit">整体时效</span>
          <span class="fontString">{{ logisticsProductOrderDTO.aging }}</span>
        </p>
        <p class="coutText" v-show="logisticsProductOrderDTO.volumeWeightRatio">
          <span class="littit">体积重比率</span>
          <span class="fontString">{{
            logisticsProductOrderDTO.volumeWeightRatio
          }}</span>
        </p>
        <p
          class="coutText"
          v-show="logisticsProductOrderDTO.weightVolumeRatioDesc"
        >
          <span class="littit">重量转换</span>
          <span class="fontString">{{
            logisticsProductOrderDTO.weightVolumeRatioDesc
          }}</span>
        </p>
        <p class="coutText">
          <span class="littit">可接货物类型：</span>
          <span class="fontString">{{
            logisticsProductOrderDTO.goodsTypeNames
          }}</span>
        </p>
      </div>
      <el-divider></el-divider>
      <div class="header_text">
        <p class="coutText">
          <span class="littit">总箱数</span>
          <span class="fontString">{{ boxList.length }}(箱)</span>
        </p>
        <p class="coutText">
          <span class="littit">总PCS</span>
          <span class="fontString">{{ getBoxpcs }}(件)</span>
        </p>
        <p class="coutText">
          <span class="littit">总体积</span>
          <span class="fontString">{{ getboxwhere }}(CBM)</span>
        </p>
        <p class="coutText">
          <span class="littit">总重量</span>
          <span class="fontString">{{ getboxWeight }}(KG)</span>
        </p>
        <p class="coutText">
          <span class="littit">计费重</span>
          <span class="fontString">{{ FBATransmoney.chargeWeight }}</span>
        </p>
      </div>
      <div class="Item_Right">
        <p
          class="coutText"
          v-for="(item, index) in FBATransmoney.goodsTypeFeeDTOS"
          :key="index"
        >
          <span class="littit">{{ item.goodsTypeName }}</span>
          <span class="fontString">{{ item.currency }}{{ item.amount }}</span>
          <span style="margin-left: 10px">({{ item.calDesc }})</span>
        </p>
        <p
          class="coutText animate__animated animate__bounceInRight"
          v-show="THFdata.checked && THFdata.amount"
        >
          <span class="littit">提货费</span>
          <span class="fontString"
            >{{ THFdata.currency }}{{ THFdata.amount }}</span
          >
        </p>
        <div v-if="calFBAFeeIDTOS.amount">
          <div
            class="coutText animate__animated animate__bounceInRight"
            v-for="(item, index) in calFBAFeeIDTOS.feeDTOList"
            :key="index"
          >
            <span class="littit">{{ item.feeName }}</span>
            <span class="fontString">{{ item.calDesc }}</span>
          </div>
        </div>
      </div>
      <div class="Item_Right">
        <p class="">
          <span class="littit">合计费用</span>
          <span
            v-for="(item, index) in this.newArray"
            :key="index"
            v-show="item.amount > 0"
          >
            <span
              ><span class="fontString" v-show="item.currency != ''">{{
                item.currency
              }}</span>
              <span
                class="fontString"
                v-show="item.amount > 0"
                style="margin-left: 5px; margin-right: 5px"
                >{{ item.amount }}</span
              ></span
            >
            <span v-show="index == newArray.length - 1 ? false : true">+</span>
          </span>
        </p>
        <p class="coutText">
          <span class="littit">折合人民币</span>
          <span class="fontString">CNY {{ calculatePrice }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import eventBus from "./eventBus.js";
export default {
  props: {
    THFdata: {
      type: Object,
      default: () => {
        return {};
      },
    },
    calFBAFeeIDTOS: {
      type: Object,
      default: () => {
        return {};
      },
    },
    logisticsProductOrderDTO: {
      type: Object,
      default: () => {
        return {};
      },
    },
    FBATransmoney: {
      type: Object,
      default: () => {
        return {};
      },
    },
    boxList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    getBoxpcs() {
      let Totalpcs = 0;
      this.boxList.forEach((item, index) => {
        item.goodsDTOList.forEach((_item) => {
          Totalpcs += _item.num;
        });
      });
      return Totalpcs;
    },
    getboxwhere() {
      //计算总体积
      let Totalcbm = 0;
      this.boxList.forEach((item, index) => {
        Totalcbm += item.cbm;
      });
      return Totalcbm.toFixed(2);
    },
    getboxWeight() {
      let TotalWeight = 0;
      this.boxList.forEach((item, index) => {
        TotalWeight += +item.weight;
      });
      return TotalWeight.toFixed(2);
    },
    calculatePrice() {
      //计算总费用
      let Totalmoney = 0; //总费用
      let FBATransmoney = 0; //运输费
      let THFmoney = 0; //提货费
      FBATransmoney = this.FBATransmoney.cnyamount? +this.FBATransmoney.cnyamount: 0;
      if (this.THFdata.checked) {
        //如果有提货费
        THFmoney = this.THFdata.cnyamount ? +this.THFdata.cnyamount : 0;
      }
      Totalmoney = FBATransmoney + THFmoney + this.calFBAFeeIDTOS.amount;
      return Totalmoney.toFixed(2);
    },
    newArray() {
      //监听 币种
      let totalFeiyong = []; //当前勾选
      totalFeiyong.push(JSON.parse(JSON.stringify(this.FBATransmoney))); //海运费币种
      if (this.THFdata.checked) {
        totalFeiyong.push(JSON.parse(JSON.stringify(this.THFdata))); //提货费费币种
      }
      this.calFBAFeeIDTOS.feeDTOList.forEach((item) => {
        totalFeiyong.push(JSON.parse(JSON.stringify(item)));
      });
      let newArray = totalFeiyong.reduce((total, cur, index) => {
        let hasValue = total.findIndex((current) => {
          return current.currency === cur.currency;
        });
        hasValue === -1 && total.push(cur);
        hasValue !== -1 &&
          (total[hasValue].amount = this.accAdd(
            total[hasValue].amount,
            cur.amount
          ));
        return total;
      }, []);
      return newArray;
    },
  },
  methods: {
    accAdd(arg1, arg2) {
      //加法精度
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
  },
  created() {
    eventBus.$on("ChangeTHFtype", (message) => {
      this.THFdata.checked = message;
    });
  },
  mounted() {},
};
</script>
<style scoped>
.coutText {
  margin-top: 9px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.littit {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
}
.fontString {
  font-weight: bold;
}
.Item_Right {
  width: 100%;
  float: left;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}
</style>


// WEBPACK FOOTER //
// src/components/PersonalCenter/FBAheader/FBAChangedata/RightWrap.vue